import React from 'react';
import PropTypes from 'prop-types';
import css from './Caption.module.scss';

/**
 * The small muted line that explains the block above it — what a table counts, how fresh its
 * figures are, what a set of controls applies to.
 *
 * A paragraph rather than a span, because it sits between blocks rather than inside a sentence,
 * and it carries its own spacing so callers stop reaching for a margin of their own. `Text` sets
 * `margin: 0` at the same specificity as a page class and its stylesheet loads last, so those
 * margins were being dropped silently.
 *
 * Renders nothing without content, so a caption that depends on data can be passed straight in.
 */
const Caption = ({children, spacing = 'below', className = ''}) => {
  if (!children) {
    return null;
  }

  const classNames = [css.caption, css[spacing], className].filter(Boolean).join(' ');

  return (
    <p className={classNames}>
      {children}
    </p>
  );
};

Caption.propTypes = {
  children: PropTypes.node,
  spacing: PropTypes.oneOf(['below', 'above', 'none']),
  className: PropTypes.string,
};

export default Caption;
